<div class="kontainer">
  @for (tallfelt of skjema.controls; track tallfelt; let indeks = $index) {
    <input
            type="text"
            inputmode="numeric"
            maxlength="1"
            required
            autocomplete="off"
            (paste)="vedPaste($event, indeks)"
            [formControl]="tallfelt"
            data-testid="otp-input-felt"
            #inputfelt>
  }
</div>
@if(ugyldig()){
  <div class="valideringsfeil" data-testid="otp-valideringsfeil">{{'Engangskoden er ikke gyldig.'|translate}}</div>
}
